import React from 'react';
import PropTypes from 'prop-types';

import RouteBundler from 'components/RouteBundler';
import AuthorizationWrapper from 'components/Auth/AuthorizationWrapper';
import roles from 'core/roles';
import ProjectManagementTable from './Table';
import ManagedProjectView from './View';
import ManagedProjectNew from './New';
import ManagedProjectEdit from './Edit';

/* eslint-disable prettier/prettier */
const routes = [
  { path: '', component: ProjectManagementTable, exact: true },
  { path: ':id/view', component: ManagedProjectView, exact: true },
  { path: ':id/edit', component: ManagedProjectEdit, exact: true },
  { path: 'new', component: ManagedProjectNew, exact: true },
];
/* eslint-enable prettier/prettier */

class ProjectManagement extends React.Component {
  static propTypes = {
    me: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
      path: PropTypes.string.isRequired,
    }).isRequired,
  };
  render() {
    return (
      <RouteBundler
        prefix={`${this.props.match.path}/`}
        routes={routes}
        me={this.props.me}
      />
    );
  }
}

export default AuthorizationWrapper([roles.PROJECT_MANAGER, roles.ADMIN])(
  ProjectManagement,
);
